import { LoanPeriod } from "../../../../../../constants/Constants";

export const TecAssuredVehicleInputMap = {
	DLP: {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term In Months",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "new.used",
				Name: "NEW/USED",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Vehicle Purchase Price",
				DC: "deal.sale.price",
			},
		],
		21: [
			{
				Property: "serial",
				Name: "Serial Number",
				DC: "vehicle.vin",
			},
			{
				Property: "inServiceDate",
				Name: "In Service Date",
				DC: "vehicle.createdOn",
			},
			{
				Property: "manufacturer",
				Name: "Manufacturer",
				DC: "vehicle.make",
			},
			{
				Property: "model",
				Name: "Model",
				DC: "vehicle.model",
			},
			{
				Property: "modelYear",
				Name: "Model Year",
				DC: "vehicle.year",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Vehicle Purchase Price",
				DC: "deal.sale.price",
			},
		],
	},
	RS: {
		5: [
			{
				Property: "vin",
				Name: "VIN",
				DC: "vehicle.vin",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term In Months(Gap)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "inServiceDate",
				Name: "In-Service Date",
				DC: "vehicle.createdOn",
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
		],
		7: [
			{
				Property: "serial",
				Name: "Serial Number",
				DC: "vehicle.vin",
			},
			{
				Property: "amountFinanced",
				Name: "Amount Financed",
				DC: "deal.sale.amtFinanced",
			},
			{
				Property: "financeMonths",
				Name: "Finance Term (months)",
				DC: "deal.sale.term",
				transform: (term, dealObj) => {
					return getFinanceTermInMonths(term, dealObj);
				},
			},
			{
				Property: "manufacturer",
				Name: "Manufacturer (i.e.FLEETWOOD)",
				DC: "vehicle.make",
			},
			{
				Property: "model",
				Name: "Model  (i.e.C47-FLAIR)",
				DC: "vehicle.model",
			},
			{
				Property: "modelYear",
				Name: "Model Year",
				DC: "vehicle.year",
			},
			{
				Property: "msrp-nada",
				Name: "MSRP/NADA",
				DC: "vehicle.acv",
			},
			{
				Property: "new-used",
				Name: "NEW/USED",
				DC: "vehicle.newUsed",
				transform: (value) => value?.toUpperCase?.(),
			},
			{
				Property: "odometer",
				Name: "Odometer",
				DC: "vehicle.odometerOut",
			},
			{
				Property: "price",
				Name: "Purchase Price",
				DC: "deal.sale.price",
			},
		],
		21: [
			{
				Property: "serial",
				Name: "Serial Number",
				DC: "vehicle.vin",
			},
		],
	},
};

export const getValueByPath = (obj, path) => {
	if (!obj || !path) return undefined;
	return path
		.split(".")
		.reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
};

const getFinanceTermInMonths = (term, dealObj) => {
	const periodValue = dealObj.deal.sale?.loanPeriod;
	const rawTerm = Number(term);
	if (!rawTerm || typeof periodValue !== "number") return undefined;
	const period = LoanPeriod.find((p) => p.value === periodValue);
	if (!period || !period.term) return undefined;
	const months = Math.round((rawTerm / period.term) * 12);

	return months;
};
